import { Navigate, useLocation } from "react-router-dom";
import { authService } from "@/services/auth";
import PlatformShell from "@/components/shell/PlatformShell";
import TenantAdminShell from "@/components/shell/TenantAdminShell";
import UserShell from "@/components/shell/UserShell";

const PLATFORM_PREFIXES = ["/platform"];
const TENANT_ADMIN_PREFIXES = ["/settings", "/cadastros", "/operacional", "/operations"];

function startsWithAny(pathname: string, prefixes: string[]) {
  return prefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

export default function ShellRouter() {
  const location = useLocation();
  const menuProfile = authService.getMenuProfile();
  const pathname = location.pathname;

  if (startsWithAny(pathname, PLATFORM_PREFIXES)) {
    if (menuProfile !== "platform") {
      return <Navigate to="/geral" replace />;
    }
    return <PlatformShell />;
  }

  if (startsWithAny(pathname, TENANT_ADMIN_PREFIXES)) {
    if (menuProfile === "user") {
      return <Navigate to="/geral" replace />;
    }
    return menuProfile === "platform" ? <PlatformShell /> : <TenantAdminShell />;
  }

  if (menuProfile === "platform") {
    return <PlatformShell />;
  }

  if (menuProfile === "tenant_admin") {
    return <TenantAdminShell />;
  }

  return <UserShell />;
}
